import moment from "moment";
import { useTranslation } from "react-i18next";

interface DeliveryTimestampProps {
  date?: string | null;
}

const DeliveryTimestamp = (props: DeliveryTimestampProps) => {
  const { date } = props;
  const { t } = useTranslation();

  if (!date) {
    return <span>-</span>;
  }

  const formattedDate = moment(date)
    .locale(t("locale"))
    .format(t("dateTimeYearFormat") || "DD.MM.YYYY HH:mm");

  return <span>{formattedDate}</span>;
};

export default DeliveryTimestamp;
